<template>
  <div class="ai-zaosheng-wrap">
    <!-- 标准按钮样式 -->
    <button
      type="button"
      class="ai-zaosheng-trigger"
      :class="{ 
        'is-hidden': visible,
        'is-special': isSpecialPage,
        'is-positioning': isSpecialPage && !buttonPositionReady
      }"
      :style="isSpecialPage ? { right: specialButtonRight + 'px', bottom: specialButtonBottom + 'px' } : {}"
      aria-label="招生咨询"
      @click="open"
    >
      <!-- 特殊页面：GIF悬浮在按钮顶部 -->
      <img 
        v-if="isSpecialPage && buttonPositionReady" 
        :src="buttonUrl" 
        alt="" 
        class="trigger-gif"
      />
      <div class="ai-zaosheng-trigger-inner">
        <div class="ai-zaosheng-trigger-logo-wrap">
          <div v-if="logoUrl" class="ai-zaosheng-trigger-logo" :style="{ backgroundImage: `url(${logoUrl})` }"></div>
          <svg v-else viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/></svg>
        </div>
        <div class="ai-zaosheng-trigger-text">
          <span class="label">{{ isSpecialPage ? '点我详细咨询' : 'AI招生助手' }}</span>
          <span class="sub-label">上海市航空服务学校</span>
        </div>
      </div>
    </button>
    <div
      class="ai-zaosheng-overlay"
      :class="{ 'is-open': visible }"
      @click.self="close"
    >
      <div class="ai-zaosheng-modal">
        <div class="ai-zaosheng-header">
          <div class="ai-zaosheng-header-left">
            <!-- <button type="button" class="sidebar-toggle-btn" @click="toggleSidebar" :title="showSidebar ? '收起数字人' : '展开数字人'">
              <svg viewBox="0 0 24 24" width="20" height="20" v-if="showSidebar"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="currentColor"/></svg>
              <svg viewBox="0 0 24 24" width="20" height="20" v-else><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="currentColor"/></svg>
            </button> -->
            <div class="ai-zaosheng-header-logo" v-if="logoUrl" :style="{ backgroundImage: `url(${logoUrl})` }"></div>
            <h3>上海市航空服务学校 · AI招生助手</h3>
          </div>
          <div class="ai-zaosheng-header-right">
            <div class="header-contact-wrap">
              <button type="button" class="header-contact-btn">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/></svg>
                <span>咨询热线</span>
              </button>
              <div class="header-contact-popover">
                <div class="popover-item">
                  <span class="label">8:00-12:00 13:00-16:30（工作日）</span>
                  <span class="val">58989721</span>
                </div>
                <div class="popover-item">
                  <span class="label">9:00-16:00 18:00-20:00</span>
                  <span class="val">13482166490</span>
                </div>
              </div>
            </div>
            <button type="button" class="ai-zaosheng-close" aria-label="关闭" @click="close">×</button>
          </div>
        </div>
        
        <div class="ai-zaosheng-body">
          <!-- 左侧：数字人展示区 -->
          <div class="ai-zaosheng-sidebar" v-show="showSidebar">
            <div class="ai-zaosheng-avatar-container">
              <div id="ivh-model-widget" class="ivh-model-container" v-show="ivhReady"></div>
              <div class="ai-zaosheng-avatar-placeholder" v-show="!ivhReady">
                <img v-if="digitalHumanUrl" :src="digitalHumanUrl" alt="数字人" class="ai-zaosheng-avatar-img">
                <div class="avatar-glow"></div>
              </div>
              <div class="ivh-status-bar" v-if="ivhStatusText">
                <span class="ivh-status-dot" :class="{ active: ivhReady }"></span>
                <span class="ivh-status-text">{{ ivhStatusText }}</span>
              </div>
              <button type="button" class="avatar-tag-btn" @click="toggleSidebar">关闭数字人</button>
            </div>
          </div>

          <!-- 右侧：对话区 -->
          <div class="ai-zaosheng-main">
            <!-- <button type="button" class="history-icon-btn" title="历史记录" @click="toggleHistory">
              <svg viewBox="0 0 24 24" width="18" height="18"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" fill="currentColor"/></svg>
            </button> -->

            <!-- 历史记录面板 -->
            <!-- <div class="history-panel" v-if="showHistoryPanel">
              <div class="history-panel-header">
                <h4>历史对话</h4>
                <button type="button" class="history-panel-close" @click="showHistoryPanel = false">×</button>
              </div>
              <div class="history-panel-body">
                <div v-if="historyLoading" class="history-loading">加载中...</div>
                <div v-else-if="historyList.length === 0" class="history-empty">暂无历史记录</div>
                <div v-else class="history-list">
                  <div 
                    v-for="(item, idx) in historyList" 
                    :key="idx" 
                    class="history-item"
                    @click="loadHistoryItem(item)"
                  >
                    <div class="history-item-query">{{ item.query || item.question || '未知问题' }}</div>
                    <div class="history-item-answer">{{ (item.answer || item.content || '').slice(0, 60) }}...</div>
                    <div class="history-item-time">{{ item.createTime || item.time || '' }}</div>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- 顶部快捷引导区 (纵向排列) -->
            <div class="ai-zaosheng-shortcuts-top" v-if="showShortcuts">
              <div class="shortcut-list-vertical">
                <button 
                  v-for="item in categoryShortcuts[currentCategory]" 
                  :key="item" 
                  class="shortcut-item-v3"
                  @click="handleShortcut(item)"
                >
                  <span class="dot-indicator"></span>
                  {{ item }}
                </button>
              </div>
            </div>

            <div ref="messagesEl" class="ai-zaosheng-messages">
              <div
                v-for="(msg, i) in messages"
                :key="i"
                class="ai-zaosheng-msg"
                :class="msg.role"
              >
                <!-- 头像区域 (可选，目前模型回复通常带个小 logo) -->
                <div v-if="msg.role === 'bot'" class="msg-avatar bot-avatar">
                  <div class="avatar-inner" v-if="logoUrl" :style="{ backgroundImage: `url(${logoUrl})` }"></div>
                  <div class="avatar-inner default-bot-icon" v-else>AI</div>
                </div>

                <div class="msg-content">
                  <div class="bubble">
                    <template v-if="msg.typing">
                      <div class="loading-plane-container">
                        <div class="wind-lines">
                          <span class="wind-line"></span>
                          <span class="wind-line"></span>
                          <span class="wind-line"></span>
                        </div>
                        <div class="plane-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" fill="currentColor"/>
                          </svg>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div v-if="msg.role === 'bot'" class="bot-content-wrap">
                        <div class="markdown-body" v-html="renderMarkdown(msg.text)" @click="handleMarkdownClick($event, msg.sources)"></div>
                        
                        <div class="school-contact-info" v-if="msg.finished">
                          <div class="contact-title">更多信息请联系学校官方📞</div>
                          <div class="contact-item">
                            <span class="contact-number">58989721</span>
                            <span class="contact-time">工作日 8:00-12:00 / 13:00-16:30</span>
                          </div>
                          <div class="contact-item">
                            <span class="contact-number">13482166490</span>
                            <span class="contact-time">9:00-16:00 / 18:00-20:00</span>
                          </div>
                        </div>

                        <!-- 简约溯源脚注 -->
                        <div class="sources-minimal-wrap" v-if="msg.finished">
                          <span class="sources-label">来源:</span>
                          <div class="sources-tags" v-if="msg.sources && msg.sources.length">
                            <span 
                              v-for="(group, gIdx) in getGroupedSources(msg.sources)" 
                              :key="gIdx" 
                              class="source-tag-mini"
                              @click="showSourceDetail(group.segments[0])"
                              @mouseenter="showHoverContent($event, group.segments[0])"
                              @mouseleave="hideHoverContent"
                            >
                              <span class="tag-idx">[{{ gIdx + 1 }}]</span>
                              {{ group.fileName }}
                            </span>
                          </div>
                          <div v-else class="source-tag-mini-default">该内容由AI生成，注意甄别</div>
                        </div>

                        <!-- 底部栏：时间 + 操作 -->
                        <div class="bot-footer" v-if="msg.finished">
                          <div class="time">{{ msg.time }}</div>
                          <div class="msg-actions">
                            <button class="action-btn" title="复制" @click="copyText(msg.text)">
                              <svg viewBox="0 0 24 24"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
                              <span>复制</span>
                            </button>
                            <button class="action-btn" v-if="isLastBotMsg(i)" title="重新生成" @click="regenerate(i)">
                              <svg viewBox="0 0 24 24"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.07 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
                              <span>重新回答</span>
                            </button>
                            <!-- <button class="action-btn" title="分享" @click="shareMessage(msg.text)">
                              <svg viewBox="0 0 24 24"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92z"/></svg>
                              <span>分享</span>
                            </button> -->
                          </div>
                        </div>

                        <!-- 推荐问题 (仅在最后一条回复后显示) -->
                        <div class="recommended-questions" v-if="isLastBotMsg(i) && msg.finished && recommendations.length">
                          <div class="rec-title">您可以继续问：</div>
                          <div class="rec-list">
                            <button v-for="q in recommendations" :key="q" class="rec-item" @click="handleShortcut(q)">
                              {{ q }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-else>{{ msg.text }}</div>
                    </template>
                  </div>
                  <div class="time" v-if="msg.role === 'user'">{{ msg.time }}</div>
                </div>
              </div>
            </div>

            <!-- 输入区上方分类标签 (增加新建对话按钮) -->
            <div class="ai-zaosheng-category-wrap">
              <div class="category-list-bubble">
                <button type="button" class="new-chat-btn" @click="resetChat" title="新建对话">
                  <svg viewBox="0 0 24 24" width="16" height="16"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.07 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" fill="currentColor"/></svg>
                </button>
                <button 
                  v-for="cat in categories" 
                  :key="cat.name" 
                  class="category-bubble-item"
                  :class="{ 'is-active': currentCategory === cat.name }"
                  @click="handleCategoryClick(cat)"
                >
                  {{ cat.name }}
                </button>
                <div class="spacer" style="flex: 1"></div>
                <div class="brochure-btn-container">
                  <a 
                    href="https://hxai.sundeinfo.com/api/dev/file/download?id=2043901047784775681" 
                    download="2026年报考指南.pdf" 
                    target="_blank" 
                    class="brochure-btn" 
                    data-tooltip="立刻下载2026年报考指南"
                  >
                    <svg viewBox="0 0 24 24" width="14" height="14" style="margin-right: 4px"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="currentColor"/></svg>
                    2026报考指南
                  </a>
                </div>
              </div>
            </div>

            <!-- 输入区 -->
            <div class="ai-zaosheng-input-wrap">
              <div class="ai-zaosheng-input-container">
                <!-- 数字人开启气泡按钮 -->
                <button 
                  v-if="!showSidebar" 
                  type="button" 
                  class="digital-human-bubble-trigger" 
                  @click="toggleSidebar"
                  title="开启数字人"
                >
                  <svg viewBox="0 0 24 24" width="16" height="16"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" fill="currentColor"/></svg>
                  <span>AI 数字人</span>
                </button>

                <textarea
                  v-model="inputText"
                  class="ai-zaosheng-input"
                  placeholder="欢迎向我提问..."
                  rows="1"
                  @keydown.enter.exact.prevent="send"
                />
                <div class="input-actions">
                  <button
                    type="button"
                    class="ai-zaosheng-send-v2"
                    aria-label="发送"
                    v-if="!loading"
                    :disabled="!inputText.trim()"
                    @click="send"
                  >
                    <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
                  </button>
                  <button
                    type="button"
                    class="ai-zaosheng-stop-v2"
                    aria-label="停止"
                    v-else
                    @click="stopGeneration"
                  >
                    <svg viewBox="0 0 24 24"><path d="M6 6h12v12H6z"/></svg>
                  </button>
                </div>
              </div>
              <div class="input-footer-tip">内容由 AI 生成，请以学校官方简章为准</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 溯源详细弹窗 (改为点击引用时显示) -->
    <div class="source-detail-overlay" v-if="showSourceModal" @click.self="showSourceModal = false">
      <div class="source-detail-modal">
        <div class="source-detail-header">
          <h3>溯源详情</h3>
          <button type="button" @click="showSourceModal = false">×</button>
        </div>
        <div class="source-detail-body">
          <div class="source-detail-item">
            <label>来源文件</label>
            <div class="val">{{ getSourceName(activeSource) }}</div>
          </div>
          <div class="source-detail-item" v-if="activeSource?.page">
            <label>页码</label>
            <div class="val">第 {{ activeSource.page }} 页</div>
          </div>
          <div class="source-detail-item">
            <label>原文内容</label>
            <div class="val content-text">{{ activeSource?.text || activeSource?.content }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 悬浮详情卡片 -->
    <div 
      class="source-hover-popover" 
      v-if="hoverState.visible" 
      :style="{ top: hoverState.y + 'px', left: hoverState.x + 'px' }"
      @mouseenter="onPopoverMouseEnter"
      @mouseleave="onPopoverMouseLeave"
    >
      <div class="hover-popover-content">
        <div class="hover-popover-title">
          {{ getSourceName(hoverState.data) }} 
          <span v-if="hoverState.data?.page">(第{{ hoverState.data.page }}页)</span>
        </div>
        <div class="hover-popover-text">{{ hoverState.data?.text || hoverState.data?.content }}</div>
      </div>
      <div class="hover-popover-arrow"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import { getAnswer, getAnswerStream, getRecommendedQuestions, fetchEventId, clearEventId, getAnswerHistory, setAgentId, doLogin, generateSessionId, clearSessionId, getSessionId, rewriteTitle, addAnswerHistory, fetchSensitiveWords, checkSensitiveWords } from './api'
import * as _h5sdk from './api/tencent-digital-human-h5sdk.js'
import { attachChromaKey, ensureSvgFilter } from './utils/chroma-key.js'

// 音频驱动（driverType:3）：大模型流式文本 → stream-tts → PCM 音频 → IVH.play(audio) → 数字人口型同步
const cloudInit            = _h5sdk.init
const cloudRegisterEvents  = _h5sdk.registerEvents
const cloudCreateAndStart  = _h5sdk.createAndStart
const cloudBeginStream     = _h5sdk.beginStream
const cloudFeedDelta       = _h5sdk.feedStreamDelta
const cloudFlush           = _h5sdk.flushStream
const cloudInterrupt       = _h5sdk.interruptAndClear
const cloudClose           = _h5sdk.close
const cloudIsReady         = _h5sdk.isReady
const cloudIsStreamActive  = _h5sdk.isStreamActive
const cloudIsBusy          = _h5sdk.isBusy
import MarkdownIt from 'markdown-it'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'
import 'github-markdown-css/github-markdown-light.css'
import mdKatex from '@traptitech/markdown-it-katex'
import 'katex/dist/katex.min.css'

const props = defineProps({
  logoUrl: { type: String, default: '' },
  digitalHumanUrl: { type: String, default: '' },
  buttonUrl: { type: String, default: '/button.gif' },
})

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: false,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return '<pre class="hljs"><code>' +
               hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
               '</code></pre>';
      } catch (__) {}
    }
    return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
  }
}).use(mdKatex, { throwOnError: false, errorColor: '#cc0000' })

function renderMarkdown(text) {
  // 保护流式输出中尚未闭合的 LaTeX 公式，避免 KaTeX 解析报错
  // 统计单行 $ 数量，若为奇数则末尾补一个 $ 使其闭合
  const safe = protectUnclosedLatex(text || '')
  let html = md.render(safe)
  return html.replace(/\[(\d+)\]/g, (match, num) => {
    return `<sup class="citation-tag" data-idx="${num}">${num}</sup>`
  })
}

function protectUnclosedLatex(text) {
  // 处理块级公式 $$...$$
  const blockCount = (text.match(/\$\$/g) || []).length
  if (blockCount % 2 !== 0) text = text + '$$'

  // 处理行内公式 $...$（排除 $$）
  // 将 $$ 临时占位，数单 $ 数量
  const placeholder = '\x00'
  let t = text.replace(/\$\$/g, placeholder)
  const inlineCount = (t.match(/\$/g) || []).length
  if (inlineCount % 2 !== 0) text = text + '$'

  return text
}

function copyText(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      alert('已复制到剪切板')
    })
  } else {
    const input = document.createElement('textarea')
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    alert('已复制到剪切板')
  }
}

const visible = ref(false)
const inputText = ref('')
const messages = ref([])
const loading = ref(false)
const messagesEl = ref(null)
const currentStream = ref(null)
const recommendations = ref([])
const showShortcuts = ref(true)
let scrollRequest = null

// 溯源详细弹窗
const activeSource = ref(null)
const showSourceModal = ref(false)

// 侧边栏显示状态
const showSidebar = ref(true)
let _userClosedDigitalHuman = false

// 判断是否为特殊页面（显示GIF在按钮顶部的页面）
const isSpecialPage = computed(() => {
  const url = window.location.href
  return url.includes('webzs/xsbm/index_shhkfwxx.shtml')
})

// 特殊页面按钮位置（与 .center_main_center 对齐）
const specialButtonRight = ref(24)  // 默认 24px
const specialButtonBottom = ref(24) // 默认 24px
const buttonPositionReady = ref(false) // 位置计算完成标志
let _resizeObserver = null

// 计算按钮位置
function updateSpecialButtonPosition() {
  if (!isSpecialPage.value) return
  
  const targetEl = document.querySelector('.center_main_center')
  const buttonEl = document.querySelector('.ai-zaosheng-trigger')
  if (targetEl && buttonEl) {
    const rect = targetEl.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const buttonWidth = buttonEl.offsetWidth
    
    // 计算中点：.center_main_center 右边界 和 视口右边界 的中点
    const centerPoint = (rect.right + windowWidth) / 2
    
    // 按钮 left = 中点 - 按钮宽度/2
    const proposedLeft = centerPoint - buttonWidth / 2
    
    // 计算垂直位置：与目标元素底边对齐
    const proposedBottom = windowHeight - rect.bottom
    
    // 如果位置足够（left >= 0 且右边不超出视口），则使用计算值
    if (proposedLeft >= 0 && proposedLeft + buttonWidth <= windowWidth) {
      // 将 left 转换为 right（为了兼容原有样式）
      specialButtonRight.value = windowWidth - proposedLeft - buttonWidth
      specialButtonBottom.value = Math.max(0, proposedBottom)
    } else {
      // 位置不够，使用默认
      specialButtonRight.value = 24
      specialButtonBottom.value = 24
    }
  } else {
    // 目标元素不存在时使用默认值
    specialButtonRight.value = 24
    specialButtonBottom.value = 24
  }
  
  // 位置计算完成，显示按钮
  buttonPositionReady.value = true
}

// 初始化位置监听
function initSpecialButtonPositionWatcher() {
  if (!isSpecialPage.value) return
  
  // 立即计算一次
  updateSpecialButtonPosition()
  
  // 监听窗口大小变化
  window.addEventListener('resize', updateSpecialButtonPosition)
  
  // 使用 ResizeObserver 监听目标元素变化
  const targetEl = document.querySelector('.center_main_center')
  if (targetEl && window.ResizeObserver) {
    _resizeObserver = new ResizeObserver(() => {
      updateSpecialButtonPosition()
    })
    _resizeObserver.observe(targetEl)
  }
  
  // 监听滚动
  window.addEventListener('scroll', updateSpecialButtonPosition, true)
}

// 清理监听器
function cleanupSpecialButtonPositionWatcher() {
  window.removeEventListener('resize', updateSpecialButtonPosition)
  window.removeEventListener('scroll', updateSpecialButtonPosition, true)
  if (_resizeObserver) {
    _resizeObserver.disconnect()
    _resizeObserver = null
  }
}

async function toggleSidebar() {
  showSidebar.value = !showSidebar.value

  // 关闭侧边栏时直接关闭数字人服务会话，并记住用户选择
  if (!showSidebar.value) {
    _userClosedDigitalHuman = true
    await destroyCloudDigitalHuman()
    return
  }

  // 用户手动重新打开数字人，清除关闭标记
  _userClosedDigitalHuman = false
  _closingIntentionally = false
  if (visible.value && enableH5Sdk && !cloudIsReady()) {
    ivhStatusText.value = '正在加载，请稍后提问'
    nextTick(() => initCloudDigitalHuman())
  }
}

// 云渲染数字人状态
const ivhReady = ref(false)
const ivhStatusText = ref('')
const enableH5Sdk = import.meta.env.VITE_ENABLE_DIGITAL_HUMAN === 'true'

let _sdkInited = false
let _sdkObserver = null
let _ivhLayoutObserver = null
let _ivhLayoutRaf = null
let _chromaKey = null

function ensureChromaKey(ivhRoot) {
  const root = ivhRoot || document.getElementById('ivh-model-widget')
  if (!root) return
  if (!_chromaKey) {
    _chromaKey = attachChromaKey(root, { objectPositionX: 0.46 })
  } else {
    _chromaKey.refresh()
  }
}

function destroyChromaKey() {
  if (_chromaKey) {
    _chromaKey.destroy()
    _chromaKey = null
  }
}

/** TCPlayer 会给 #ivh-video 写死内联 width/height（如 981×552），侧栏只有约 260px 宽，必须按容器铺满 */
function applyIvhPlayerFillContainer(ivhRoot) {
  const root = ivhRoot || document.getElementById('ivh-model-widget')
  if (!root) return

  root.style.setProperty('display', 'flex', 'important')
  root.style.setProperty('align-items', 'center', 'important')
  root.style.setProperty('justify-content', 'center', 'important')
  root.style.setProperty('overflow', 'hidden', 'important')

  const player = root.querySelector('#ivh-video') || root.querySelector('.tcplayer.video-js')
  if (!player?.style) return

  player.style.setProperty('width', '100%', 'important')
  player.style.setProperty('height', '100%', 'important')
  player.style.setProperty('max-width', '100%', 'important')
  player.style.setProperty('max-height', '100%', 'important')
  player.style.setProperty('min-width', '0', 'important')
  player.style.setProperty('left', '0', 'important')
  player.style.setProperty('top', '0', 'important')
  player.style.setProperty('transform', 'none', 'important')
}

function scheduleIvhPlayerLayout(ivhRoot) {
  if (_ivhLayoutRaf) cancelAnimationFrame(_ivhLayoutRaf)
  _ivhLayoutRaf = requestAnimationFrame(() => {
    _ivhLayoutRaf = null
    applyIvhPlayerFillContainer(ivhRoot)
    ensureChromaKey(ivhRoot)
  })
}

async function waitForIVH(timeout = 5000) {
  if (window.IVH) return true
  const start = Date.now()
  while (Date.now() - start < timeout) {
    await new Promise(r => setTimeout(r, 200))
    if (window.IVH) return true
  }
  return false
}

let _initInProgress = false
let _closingIntentionally = false
let _idleTimer = null
const IDLE_TIMEOUT = 1 * 60 * 1000

function resetIdleTimer() {
  if (_idleTimer) clearTimeout(_idleTimer)
  if (!cloudIsReady()) return
  _idleTimer = setTimeout(async () => {
    if (loading.value || cloudIsBusy()) {
      resetIdleTimer()
      return
    }
    if (cloudIsReady()) {
      console.log('[Widget] 空闲超时，主动关闭数字人会话')
      await destroyCloudDigitalHuman()
      ivhStatusText.value = '排队中，请关闭重试'
    }
  }, IDLE_TIMEOUT)
}

function clearIdleTimer() {
  if (_idleTimer) { clearTimeout(_idleTimer); _idleTimer = null }
}

async function initCloudDigitalHuman() {
  if (!enableH5Sdk) { ivhStatusText.value = ''; return }
  if (_initInProgress) return
  if (cloudIsReady()) {
    ivhReady.value = true
    ivhStatusText.value = '航校服务之星'
    resetIdleTimer()
    return
  }

  _initInProgress = true
  try {
    if (!window.IVH) {
      ivhStatusText.value = '正在加载，请稍后提问'
      const ok = await waitForIVH()
      if (!ok) {
        console.warn('[Widget] window.IVH 加载超时')
        ivhStatusText.value = '排队中，请关闭重试'
        return
      }
    }

    ivhStatusText.value = '正在加载，请稍后提问'
    console.log('[Widget] 音频驱动（driverType:3），流式文本 → stream-tts → PCM → 数字人')

    const _ivhContainer = document.getElementById('ivh-model-widget')
    if (!_ivhContainer) {
      console.error('[Widget] #ivh-model-widget 不存在，无法初始化数字人')
      ivhStatusText.value = '排队中，请关闭重试'
      return
    }

    if (!_sdkInited) {
      const _slotId = Math.floor(Math.random() * 5) + 1
      cloudInit(_ivhContainer, { userId: `zaosheng_widget_${_slotId}`, isAreaStyle: true })
      console.log('[Widget] 分配流槽位:', _slotId)

      _sdkObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.target?.id === 'ivh-video') {
            scheduleIvhPlayerLayout(_ivhContainer)
            continue
          }
          for (const node of m.addedNodes) {
            if (node.nodeType !== 1) continue
            if (node.nodeName === 'VIDEO') {
              node.setAttribute('autoplay', '')
              node.setAttribute('playsinline', '')
              node.muted = false
              node.play().catch(() => {
                node.muted = true
                node.play().then(() => { node.muted = false }).catch(() => {})
              })
              ensureChromaKey(_ivhContainer)
            }
            if (node.id === 'ivh-video' || node.querySelector?.('#ivh-video')) {
              scheduleIvhPlayerLayout(_ivhContainer)
            }
          }
        }
      })
      _sdkObserver.observe(_ivhContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style'],
      })

      const _layoutParent = _ivhContainer.parentElement
      if (_layoutParent && typeof ResizeObserver !== 'undefined') {
        _ivhLayoutObserver = new ResizeObserver(() => scheduleIvhPlayerLayout(_ivhContainer))
        _ivhLayoutObserver.observe(_ivhContainer)
        _ivhLayoutObserver.observe(_layoutParent)
      }

      cloudRegisterEvents({
        onError: (e) => {
          console.error('[Widget Cloud] error:', e)
          if (!cloudIsReady()) {
            ivhReady.value = false
            recoverCloudDigitalHuman()
          }
        },
        onCanplay: () => {
          ivhReady.value = true
          ivhStatusText.value = '航校服务之星'
          scheduleIvhPlayerLayout(_ivhContainer)
          const v = _ivhContainer?.querySelector('video')
          if (v) v.play().catch(() => {})
          ensureChromaKey(_ivhContainer)
        },
        onSessionEnd: () => {
          ivhReady.value = false
          recoverCloudDigitalHuman()
        },
        onPlayStreamStop: () => {
          if (!cloudIsReady()) {
            ivhReady.value = false
            recoverCloudDigitalHuman()
          }
        },
        onSpeakStart: () => {
          clearIdleTimer()
        },
        onSpeakEnd: () => {
          if (!loading.value && !cloudIsBusy()) resetIdleTimer()
        },
      })

      _sdkInited = true
    }

    ivhStatusText.value = '正在加载，请稍后提问'
    const result = await cloudCreateAndStart()
    if (result) {
      ivhReady.value = true
      await nextTick()
      scheduleIvhPlayerLayout(_ivhContainer)
      setTimeout(() => scheduleIvhPlayerLayout(_ivhContainer), 100)
      setTimeout(() => scheduleIvhPlayerLayout(_ivhContainer), 500)
      ivhStatusText.value = '航校服务之星'
      resetIdleTimer()
    } else {
      ivhStatusText.value = '排队中，请关闭重试'
      ivhReady.value = false
      console.warn('[Widget Cloud] 数字人建流失败')
    }
  } catch (e) {
    console.error('[Widget Cloud] init error:', e)
    ivhStatusText.value = '排队中，请关闭重试'
    ivhReady.value = false
  } finally {
    _initInProgress = false
  }
}

function recoverCloudDigitalHuman() {
  if (_closingIntentionally || _userClosedDigitalHuman || !visible.value) {
    if (!_closingIntentionally) ivhStatusText.value = '排队中，请关闭重试'
    return
  }
  ivhStatusText.value = '正在加载，请稍后提问'
  nextTick(() => initCloudDigitalHuman())
}

async function destroyCloudDigitalHuman() {
  _closingIntentionally = true
  clearIdleTimer()
  const root = document.getElementById('ivh-model-widget')
  if (root) {
    root.style.setProperty('opacity', '0', 'important')
    root.style.setProperty('visibility', 'hidden', 'important')
  }
  ivhReady.value = false
  await nextTick()
  destroyChromaKey()
  if (_sdkObserver) { _sdkObserver.disconnect(); _sdkObserver = null }
  if (_ivhLayoutObserver) { _ivhLayoutObserver.disconnect(); _ivhLayoutObserver = null }
  if (_ivhLayoutRaf) { cancelAnimationFrame(_ivhLayoutRaf); _ivhLayoutRaf = null }
  _sdkInited = false
  try {
    await cloudClose()
  } finally {
    if (root) {
      root.style.removeProperty('opacity')
      root.style.removeProperty('visibility')
    }
  }
  ivhStatusText.value = ''
}

// 悬浮溯源处理
const hoverState = ref({
  visible: false,
  x: 0,
  y: 0,
  data: null
})
let hideTimer = null

function showHoverContent(e, data) {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  const rect = e.target.getBoundingClientRect()
  hoverState.value = {
    visible: true,
    x: rect.left + rect.width / 2,
    y: rect.top - 10,
    data: data
  }
}

function hideHoverContent() {
  hideTimer = setTimeout(() => {
    hoverState.value.visible = false
    hideTimer = null
  }, 200) // 给予 200ms 缓冲时间移入悬浮窗
}

function onPopoverMouseEnter() {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
}

function onPopoverMouseLeave() {
  hideHoverContent()
}

function getGroupedSources(sources) {
  if (!sources || !sources.length) return []
  const groups = {}
  sources.forEach(src => {
    const name = getSourceName(src)
    if (!groups[name]) {
      groups[name] = { fileName: name, segments: [] }
    }
    groups[name].segments.push(src)
  })
  return Object.values(groups)
}

function getSourceName(src) {
  if (!src) return '参考文档'
  // 针对新接口格式：优先取 file_name
  return src.file_name || src.title || src.name || src.metadata?.title || src.metadata?.name || src.metadata?.source || '参考文档'
}

function showSourceDetail(src) {
  if (!src) return
  activeSource.value = src
  showSourceModal.value = true
}

function handleMarkdownClick(e, msgSources) {
  const target = e.target
  if (target.classList.contains('citation-tag')) {
    const idx = parseInt(target.getAttribute('data-idx'))
    // 检查这个消息是否真的有对应的溯源信息
    if (msgSources && msgSources[idx - 1]) {
      showSourceDetail(msgSources[idx - 1])
    } else {
      console.warn('未找到对应索引的溯源信息:', idx, msgSources)
    }
  }
}


// 快捷功能与分类 — 每个分类对应不同的 agentId
const categories = [
  { 
    name: '招生咨询', 
    type: 'shortcuts',
    agentId: '1992229605230174209',
    shortcuts: [
      '哪些学生可以报考？',
      '学校哪些专业需要提前面试？',
      '学校提供住宿吗？',

    ]
  },
  // { 
  //   name: '校园生活', 
  //   type: 'shortcuts',
  //   agentId: '2035965044738666498',
  //   shortcuts: [
  //     '哪些学生可以报考？随迁子女可以吗？',
  //     '学费多少？有没有资助政策？'
  //   ]
  // },
  // { 
  //   name: '就业去向', 
  //   type: 'shortcuts',
  //   agentId: '1992229605230174209',
  //   shortcuts: [
  //     '学校推荐就业吗？就业率怎么样？',
  //     '贯通类学生需要参加统一考试吗？'
  //   ]
  // }
]

const currentCategory = ref(categories[0].name)
const currentAgentId = ref(categories[0].agentId)

const categoryShortcuts = Object.fromEntries(
  categories.map(c => [c.name, c.shortcuts])
)

function handleCategoryClick(cat) {
  if (cat.type === 'shortcuts') {
    const switched = currentCategory.value !== cat.name && currentAgentId.value !== cat.agentId
    currentCategory.value = cat.name
    if (currentAgentId.value !== cat.agentId) {
      currentAgentId.value = cat.agentId
      switchAgent(cat.agentId)
    }
  }
}

function switchAgent(agentId) {
  messages.value = []
  recommendations.value = []
  showShortcuts.value = true
  localStorage.removeItem('chat_conversation_id')
  clearEventId()
  clearSessionId()
  setAgentId(agentId)
  fetchEventId()
  stopGeneration()
}

async function resetChat() {
  messages.value = []
  recommendations.value = []
  showShortcuts.value = true
  localStorage.removeItem('chat_conversation_id')
  clearEventId()
  clearSessionId()
  setAgentId(currentAgentId.value)
  fetchEventId()
  stopGeneration()

  if (enableH5Sdk && !_userClosedDigitalHuman) {
    await destroyCloudDigitalHuman()
    nextTick(() => initCloudDigitalHuman())
  }
}

const showHistoryPanel = ref(false)
const historyList = ref([])
const historyLoading = ref(false)

async function toggleHistory() {
  showHistoryPanel.value = !showHistoryPanel.value
  if (showHistoryPanel.value) {
    historyLoading.value = true
    try {
      historyList.value = await getAnswerHistory()
    } catch (err) {
      console.error('Load history error:', err)
      historyList.value = []
    } finally {
      historyLoading.value = false
    }
  }
}

function loadHistoryItem(item) {
  const q = item.query || item.question || ''
  const a = item.answer || item.content || ''
  if (q || a) {
    messages.value = []
    showShortcuts.value = false
    if (q) messages.value.push({ role: 'user', text: q, time: item.createTime || '' })
    if (a) messages.value.push({ role: 'bot', text: a, time: item.createTime || '', finished: true, sources: item.sources || [] })
  }
  showHistoryPanel.value = false
}

watch(inputText, (newVal) => {
  nextTick(() => {
    const el = document.querySelector('.ai-zaosheng-input')
    if (el) {
      el.style.height = 'auto'
      el.style.height = (el.scrollHeight) + 'px'
    }
  })
})

function isLastBotMsg(index) {
  for (let i = messages.value.length - 1; i > index; i--) {
    if (messages.value[i].role === 'bot') return false
  }
  return messages.value[index].role === 'bot'
}

async function regenerate(index) {
  // 找到该回复对应的上一条用户提问
  let userQuery = ''
  for (let i = index - 1; i >= 0; i--) {
    if (messages.value[i].role === 'user') {
      userQuery = messages.value[i].text
      break
    }
  }
  if (userQuery) {
    // 移除当前回复及之后的消息（可选，或者直接在末尾新增）
    // 这里采用直接在末尾发起新请求的逻辑，不删除历史，符合流式对话习惯
    inputText.value = userQuery
    send()
  }
}

function shareMessage(text) {
  const url = window.location.href
  const shareText = `招生助手回复：${text.slice(0, 50)}... \n查看详情：${url}`
  if (navigator.share) {
    navigator.share({
      title: '招生助手咨询分享',
      text: shareText,
      url: url
    }).catch(console.error)
  } else {
    copyText(shareText)
    alert('分享信息已复制到剪贴板')
  }
}

async function updateRecommendations() {
  const history = messages.value.map(m => ({
    role: m.role === 'bot' ? 'assistant' : 'user',
    content: m.text
  }))

  if (history.length === 0) {
    recommendations.value = []
    return
  }

  try {
    const questions = await getRecommendedQuestions(history)
    recommendations.value = questions
    nextTick(() => {
      if (messagesEl.value) messagesEl.value.scrollTop = messagesEl.value.scrollHeight
    })
  } catch (err) {
    console.error('Update recommendations error:', err)
    recommendations.value = []
  }
}

function handleShortcut(item) {
  inputText.value = item
  showShortcuts.value = false
  send()
}

function timeStr() {
  const d = new Date()
  const h = d.getHours()
  const m = d.getMinutes()
  return `${h < 10 ? '0' : ''}${h}:${m < 10 ? '0' : ''}${m}`
}

function unlockAudio() {
  // Web Audio API 解锁
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)()
    const buf = ctx.createBuffer(1, 1, 22050)
    const src = ctx.createBufferSource()
    src.buffer = buf
    src.connect(ctx.destination)
    src.start(0)
    ctx.resume().then(() => ctx.close())
  } catch (_) {}
  // HTML Audio 解锁（iOS Safari 必须）
  try {
    const a = new Audio('data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA=')
    a.play().catch(() => {})
  } catch (_) {}
  // 同时尝试直接解除数字人 video 静音
  tryUnmuteIvhVideo()
}

function tryUnmuteIvhVideo() {
  const v = document.querySelector('#ivh-model-widget video')
  if (!v) return
  v.muted = false
  if (v.paused) {
    v.play().catch(() => { v.muted = true; v.play().catch(() => {}) })
  }
}

function open() {
  unlockAudio()
  visible.value = true
  showSidebar.value = true
  _userClosedDigitalHuman = false
  _closingIntentionally = false
  if (enableH5Sdk) {
    ivhStatusText.value = '正在加载，请稍后提问'
    nextTick(() => initCloudDigitalHuman())
  }
}
async function close() {
  visible.value = false
  await destroyCloudDigitalHuman()
}

function stopGeneration() {
  if (currentStream.value) {
    currentStream.value.abort()
    currentStream.value = null
  }
  loading.value = false
  cloudInterrupt()

  const lastMsg = messages.value[messages.value.length - 1]
  if (lastMsg && lastMsg.role === 'bot' && !lastMsg.finished) {
    lastMsg.typing = false
    if (!lastMsg.text) {
      messages.value.pop()
    } else {
      lastMsg.finished = true
    }
  }
}

async function send() {
  const text = inputText.value.trim()
  if (!text || loading.value) return

  // 敏感词检测
  const sensitiveCheck = await checkSensitiveWords(text)
  if (sensitiveCheck.hit) {
    if (!getSessionId()) generateSessionId()
    const sid = getSessionId()
    const qTime = Date.now()
    const reply = sensitiveCheck.triggerContent || '您的输入包含敏感内容，请修改后重试。'
    messages.value.push({ role: 'user', text, time: timeStr() })
    messages.value.push({ role: 'bot', text: reply, time: timeStr(), finished: true, sources: [] })
    inputText.value = ''
    showShortcuts.value = false
    await nextTick()
    if (messagesEl.value) messagesEl.value.scrollTop = messagesEl.value.scrollHeight
    const cTime = Date.now()
    addAnswerHistory({ chatId: sid, name: text.slice(0, 20), sceneId: undefined, question: text, questionTime: qTime, content: reply, contentTime: cTime, documents: [] })
    return
  }

  clearIdleTimer()
  tryUnmuteIvhVideo()
  inputText.value = ''
  showShortcuts.value = false
  recommendations.value = []

  // 新对话时生成 session_id
  if (!getSessionId()) generateSessionId()
  const sessionId = getSessionId()
  const questionTime = Date.now()

  // 开始新一轮流式播报
  if (cloudIsReady()) cloudBeginStream()
  messages.value.push({ role: 'user', text, time: timeStr() })
  await nextTick()
  if (messagesEl.value) messagesEl.value.scrollTop = messagesEl.value.scrollHeight

  const typingIdx = messages.value.length
  messages.value.push({ 
    role: 'bot', 
    text: '', 
    typing: true, 
    time: timeStr(), 
    sources: [],
    finished: false
  })
  loading.value = true
  await nextTick()
  if (messagesEl.value) messagesEl.value.scrollTop = messagesEl.value.scrollHeight

  if (!loading.value) return

  const stream = getAnswerStream(text, {
    sessionId,
    onMessage: (accumulated, sources) => {
      if (!loading.value) return
      
      const prevLen = messages.value[typingIdx]?.text?.length || 0
      if (messages.value[typingIdx]) {
        messages.value[typingIdx].typing = false
        messages.value[typingIdx].text = accumulated
        if (sources && Array.isArray(sources) && sources.length > 0) {
          messages.value[typingIdx].sources = [...sources]
        }
      }

      // 流式增量文本 → 喂给云端 TTS（command:'stream'）
      const delta = accumulated.slice(prevLen)
      if (delta && cloudIsReady()) {
        cloudFeedDelta(delta)
      }

      if (scrollRequest) cancelAnimationFrame(scrollRequest)
      scrollRequest = requestAnimationFrame(scrollToBottom)
    },
    onDone: () => {
      if (!loading.value) return

      const botAnswer = messages.value[typingIdx]?.text || ''
      if (messages.value[typingIdx]) {
        messages.value[typingIdx].finished = true
      }
      loading.value = false
      currentStream.value = null
      // 流式结束，通知云端 TTS 播完（空闲计时由 onSpeakEnd 触发）
      if (cloudIsReady()) {
        cloudFlush()
      }
      nextTick(() => {
        if (messagesEl.value) messagesEl.value.scrollTop = messagesEl.value.scrollHeight
      })
      updateRecommendations()

      // 生成会话标题并存入历史记录（异步，不阻塞 UI）
      if (botAnswer) {
        const contentTime = Date.now()
        const botSources = messages.value[typingIdx]?.sources || []
        rewriteTitle(text, botAnswer).then(title => {
          addAnswerHistory({
            chatId: sessionId,
            name: title,
            sceneId: undefined,
            question: text,
            questionTime,
            content: botAnswer,
            contentTime,
            documents: botSources,
          })
        })
      }
    },
    onError: (err) => {
      if (!loading.value) return

      if (messages.value[typingIdx]) {
        messages.value[typingIdx].typing = false
        messages.value[typingIdx].finished = true
        messages.value[typingIdx].text = '抱歉，请求出错了。请稍后再试。'
      }
      loading.value = false
      currentStream.value = null
      cloudInterrupt()
    }
  })
  
  // 再次检查，防止在创建 stream 的瞬间被取消
  if (!loading.value) {
    stream.abort()
    return
  }
  
  currentStream.value = stream
}

function scrollToBottom() {
  if (messagesEl.value) {
    const el = messagesEl.value
    // 只有当用户在底部附近（100px内）时，才自动滚动到最新内容
    // 这样用户手动往回滑看历史记录时，不会被新消息强制拉回到底部
    const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 100
    if (isNearBottom) {
      el.scrollTop = el.scrollHeight
    }
  }
}

// watch(messages, () => nextTick(scrollToBottom), { deep: true }) // 已通过 rAF 在 onMessage 中节流滚动

function handlePageUnload() {
  destroyCloudDigitalHuman()
}

onMounted(async () => {
  ensureSvgFilter()
  await doLogin()
  setAgentId(currentAgentId.value)
  fetchEventId()
  fetchSensitiveWords()
  window.addEventListener('beforeunload', handlePageUnload)
  
  // 初始化特殊页面按钮位置监听
  initSpecialButtonPositionWatcher()
})

onBeforeUnmount(async () => {
  window.removeEventListener('beforeunload', handlePageUnload)
  await destroyCloudDigitalHuman()
  
  // 清理特殊页面按钮位置监听
  cleanupSpecialButtonPositionWatcher()
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;600;700&display=swap');

.ai-zaosheng-wrap {
  font-family: "Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif;
  box-sizing: border-box;
}
.ai-zaosheng-wrap * {
  box-sizing: border-box;
}

.ai-zaosheng-trigger {
  position: fixed;
  right: 24px;
  bottom: 24px;
  height: 56px;
  border-radius: 28px;
  background: linear-gradient(135deg,#e85d04 0%, #dc2f02 100%);
  color: #fff;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(232, 93, 4, 0.45);
  z-index: 99998;
  padding: 0 20px 0 0;
  display: flex;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s, visibility 0.2s, right 0.3s, bottom 0.3s;
  animation: ai-zaosheng-float 3s ease-in-out infinite;
}
/* 特殊页面：允许动态位置，去掉位置过渡动画 */
.ai-zaosheng-trigger.is-special {
  animation: none;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s, visibility 0.2s;
}
.ai-zaosheng-trigger.is-positioning {
  opacity: 0;
  visibility: hidden;
}
/* GIF显示 */
.ai-zaosheng-trigger .trigger-gif {
  position: absolute;
  bottom: 56px;
  left: 50%;
  transform: translateX(calc(-50% + 15px)) scale(2);
  transform-origin: bottom center;
  width: 120px;
  height: auto;
  pointer-events: none;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
  z-index: -1;
}
@keyframes ai-zaosheng-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
.ai-zaosheng-trigger.is-hidden {
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px) scale(0.9);
  animation: none;
}
.ai-zaosheng-trigger-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  z-index: 500;
}
.ai-zaosheng-trigger-logo-wrap {
  width: 56px;
  height: 56px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  padding: 8px;
  margin-right: 4px;
}
.ai-zaosheng-trigger-logo {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
}
.ai-zaosheng-trigger-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: nowrap;
}
.ai-zaosheng-trigger-text .label {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
}
.ai-zaosheng-trigger-text .sub-label {
  font-size: 11px;
  opacity: 0.9;
  line-height: 1.2;
}
.ai-zaosheng-trigger:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 24px rgba(232, 93, 4, 0.5);
}
.ai-zaosheng-trigger svg {
  width: 28px;
  height: 28px;
  fill:#e85d04;
}

.ai-zaosheng-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s, visibility 0.25s;
}
.ai-zaosheng-overlay.is-open {
  opacity: 1;
  visibility: visible;
}

.ai-zaosheng-modal {
  position: fixed;
  right: 24px;
  bottom: 24px; /* 对齐触发器 */
  width: 1000px;
  max-width: calc(100vw - 48px);
  height: 650px;
  max-height: calc(100vh - 48px);
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 60px rgba(0, 0, 0, 0.25);
  z-index: 100000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px) scale(0.95);
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), 
              visibility 0.3s cubic-bezier(0.4, 0, 0.2, 1), 
              transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.ai-zaosheng-overlay.is-open .ai-zaosheng-modal {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

/* 顶部栏 */
.ai-zaosheng-header {
  padding: 12px 24px;
  background: #fff;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  border-bottom: 1px solid #f0f0f0;
}
.ai-zaosheng-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sidebar-toggle-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: -4px;
}
.sidebar-toggle-btn:hover {
  background: #f5f5f5;
  color:#e85d04;
}
.ai-zaosheng-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-contact-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.header-contact-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.2s;
}
.header-contact-btn:hover {
  background: #fff6f0;
  color:#e85d04;
}
.header-contact-popover {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  padding: 12px;
  width: 210px;
  border: 1px solid #f0f0f0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.2s;
  z-index: 100;
}
.header-contact-wrap:hover .header-contact-popover {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.header-contact-popover .popover-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.header-contact-popover .popover-item:last-child {
  margin-bottom: 0;
}
.header-contact-popover .label {
  font-size: 11px;
  color: #999;
  margin-bottom: 2px;
}
.header-contact-popover .val {
  font-size: 14px;
  color:#e85d04;
  font-weight: 500;
  text-decoration: none;
}
.header-contact-popover .val:hover {
  text-decoration: underline;
}
.ai-zaosheng-header-logo {
  width: 28px;
  height: 28px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.ai-zaosheng-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #666;
  letter-spacing: 0.2px;
}

/* 顶部操作按钮 */
.history-icon-btn {
  position: absolute;
  top: 12px;
  right: 56px; /* Offset to avoid close button */
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: all 0.2s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.history-icon-btn:hover {
  background: #f5f5f5;
  color:#e85d04;
}

/* 历史记录面板 */
/* .history-panel {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 300px;
  max-height: 400px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 20;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  animation: popup-fade-in 0.2s ease-out;
}
.history-panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.history-panel-header h4 {
  margin: 0;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.history-panel-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0 4px;
}
.history-panel-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}
.history-loading, .history-empty {
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 24px 0;
}
.history-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.history-item {
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8f9fb;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.history-item:hover {
  background: #fff6f0;
  border-color:#e85d04;
}
.history-item-query {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.history-item-answer {
  font-size: 12px;
  color: #888;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.history-item-time {
  font-size: 11px;
  color: #ccc;
  margin-top: 4px;
} */

/* 顶部快捷引导 (纵向排布) */
.ai-zaosheng-shortcuts-top {
  padding: 40px 24px 0; /* Increase top padding */
  background: #fff;
}
.shortcut-list-vertical {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.shortcut-item-v3 {
  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  color: #555;
  padding: 4px 0;
  font-size: 15px; /* Increase font size */
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}
.dot-indicator {
  width: 7px;
  height: 7px;
  background: #e0e0e0;
  border-radius: 50%;
  flex-shrink: 0;
}
.shortcut-item-v3:hover {
  color:#e85d04;
  transform: translateX(4px); /* Add slight hover effect */
}
.shortcut-item-v3:hover .dot-indicator {
  background:#e85d04;
  box-shadow: 0 0 8px rgba(232, 93, 4, 0.4);
}

/* 输入区上方分类标签 (气泡形式) */
.ai-zaosheng-category-wrap {
  padding: 0 24px;
  margin-bottom: 0px;
  position: relative;
  z-index: 100; /* 确保在消息区域上方，防止被遮挡 */
}
.category-list-bubble {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: visible; /* 改为 visible，允许悬浮提示和弹窗显示在容器外 */
  padding-bottom: 4px;
}
.category-list-bubble::-webkit-scrollbar {
  height: 0;
}
.new-chat-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border: none;
  border-radius: 50%; /* Pure circle */
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  margin-right: 2px;
}
.new-chat-btn:hover {
  background: #fff6f0;
  color:#e85d04;
  transform: rotate(90deg); /* Slight rotation on hover */
}
.category-bubble-item {
  height: 28px; /* Match height */
  font-size: 13px;
  color: #666;
  background: #f8f9fb;
  border: 1px solid #f0f0f0;
  padding: 0 16px;
  border-radius: 16px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  display: flex;
  align-items: center;
}
.category-bubble-item:hover {
  border-color:#e85d04;
  color:#e85d04;
}
.category-bubble-item.is-active {
  background: #fff6f0;
  border-color:#e85d04;
  color:#e85d04;
  font-weight: 500;
}
.brochure-btn {
  height: 28px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg,#e85d04 0%, #dc2f02 100%);
  color: #fff;
  border: none;
  padding: 0 14px;
  border-radius: 14px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(232, 93, 4, 0.2);
}
.brochure-btn:hover {
  opacity: 0.9;
}

/* 内容主体区 */
.ai-zaosheng-body {
  display: flex;
  flex: 1;
  overflow: hidden;
  background: #fcfcfc;
}

/* 左侧：数字人展示区 */
.ai-zaosheng-sidebar {
  width: 300px;
  background: #f8f9fb;
  border-right: 1px solid #edf1f7;
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-shrink: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s, opacity 0.3s;
  overflow: hidden;
}
.ai-zaosheng-sidebar[style*="display: none"] {
  /* v-show adds display: none inline, but we might want to animate it */
  /* Vue's transition system is better for this, but simple v-show is fine for now */
}
.ai-zaosheng-avatar-container {
  flex: 1;
  background: linear-gradient(180deg, #f0f2f5 0%, #e6e9ef 100%);
  border-radius: 16px;
  box-shadow: inset 0 2px 10px rgba(0,0,0,0.03);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.05);
}
.ai-zaosheng-avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #e6e9ef 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.ai-zaosheng-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
  position: absolute;
  inset: 0;
  z-index: 1;
}
.avatar-glow {
  width: 120px;
  height: 120px;
  background:#e85d04;
  filter: blur(40px);
  opacity: 0.15;
  border-radius: 50%;
  animation: avatar-pulse 3s infinite;
  z-index: 0;
}
@keyframes avatar-pulse {
  0%, 100% { opacity: 0.15; transform: scale(1); }
  50% { opacity: 0.25; transform: scale(1.1); }
}
.avatar-tag-btn {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.6);
  color: #fff;
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 20px;
  backdrop-filter: blur(4px);
  z-index: 10;
  border: 1px solid rgba(255,255,255,0.2);
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-tag-btn:hover {
  background: rgba(0,0,0,0.8);
  transform: translateX(-50%) scale(1.05);
}

/* IVH/TCPlayer：SDK 会注入 .tcplayer { left:50%; transform:translateX(-50%) } + video object-fit:cover，
   在窄侧栏 + overflow:hidden 下易把人物挤向一侧并裁边。此处强制铺满容器并覆盖为 contain + 居中。 */
.ivh-model-container {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  z-index: 2;
}
.ivh-model-container :deep(#ivh-video),
.ivh-model-container :deep(.tcplayer.video-js),
.ivh-model-container :deep(.tcplayer) {
  position: absolute !important;
  inset: 0 !important;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: none !important;
  margin: 0 !important;
}
.ivh-model-container :deep(.video-js .vjs-tech),
.ivh-model-container :deep(video),
.ivh-model-container :deep(canvas) {
  display: block;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: cover !important;
  object-position: 46% center !important;
  transform: none !important;
  transform-origin: center center !important;
}
.ivh-model-container :deep(.tcplayer),
.ivh-model-container :deep(.video-js),
.ivh-model-container :deep(#ivh-video) {
  background: transparent !important;
  background-color: transparent !important;
}
.ivh-model-container :deep(video),
.ivh-model-container :deep(.vjs-tech) {
  filter: url(#dh-chroma-key-filter);
}
.ivh-model-container.dh-chroma-on :deep(video),
.ivh-model-container.dh-chroma-on :deep(.vjs-tech),
.ivh-model-container.dh-chroma-on :deep(canvas:not(.dh-chroma-canvas)) {
  opacity: 0 !important;
}
.ivh-model-container.dh-chroma-svg :deep(video),
.ivh-model-container.dh-chroma-svg :deep(.vjs-tech) {
  opacity: 1 !important;
}
.ivh-model-container.dh-chroma-svg :deep(canvas:not(.dh-chroma-canvas)) {
  opacity: 0 !important;
}

.ivh-status-bar {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  color: #fff;
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 12px;
  z-index: 10;
  white-space: nowrap;
}
.ivh-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #999;
  flex-shrink: 0;
}
.ivh-status-dot.active {
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.6);
}

/* 侧边栏联系方式 - 已移除，样式保留防止报错或后续恢复 */
.sidebar-contact {
  display: none;
}

/* 右侧：对话主区 */
.ai-zaosheng-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  position: relative;
}

/* 移除旧的切换按钮样式 */
/* .digital-human-toggle-text-btn { ... } */


.ai-zaosheng-messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: #fff;
  /* scroll-behavior: smooth; 去掉平滑滚动，流式输出时会导致卡顿感 */
}

/* 消息容器布局 */
.ai-zaosheng-msg {
  margin-bottom: 32px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.ai-zaosheng-msg:last-child {
  margin-bottom: 0;
}
.ai-zaosheng-msg.user {
  flex-direction: row-reverse;
}

/* 头像 */
.msg-avatar {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-top: 4px;
}
.avatar-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: 1px solid #eee;
}
.default-bot-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg,#e85d04 0%, #dc2f02 100%);
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}

.msg-content {
  display: flex;
  flex-direction: column;
  max-width: 85%;
  gap: 12px;
}

/* 消息气泡 - 用户 */
.ai-zaosheng-msg.user .bubble {
  background: linear-gradient(135deg,#e85d04 0%, #dc2f02 100%);
  color: #fff;
  padding: 12px 18px;
  border-radius: 18px 18px 2px 18px;
  font-size: 15px;
  line-height: 1.6;
  box-shadow: 0 4px 12px rgba(232, 93, 4, 0.15);
}

/* 消息展示 - 机器人 (无边界样式) */
.ai-zaosheng-msg.bot .bubble {
  background: transparent;
  padding: 4px 0;
  border: none;
  font-size: 15px;
  line-height: 1.7;
  color: #333;
}
.bot-content-wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.school-contact-info {
  margin-top: 4px;
  padding: 10px 12px;
  background: linear-gradient(135deg, #fff7ed, #fff1e6);
  border-left: 3px solid #f59e0b;
  border-radius: 6px;
  font-size: 14px;
  color: #78350f;
  line-height: 1.6;
}
.contact-title {
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 2px;
  color: #b45309;
}
.contact-item {
  display: inline;
}
.contact-item + .contact-item::before {
  content: "｜";
  color: #d4a574;
  margin: 0 4px;
}
.contact-number {
  font-weight: 600;
  color: #d97706;
}
.contact-time {
  font-size: 11px;
  color: #92400e;
  opacity: 0.7;
  margin-left: 6px;
}

.ai-zaosheng-msg.bot .markdown-body {
  background: transparent !important;
  font-size: 15px !important;
  line-height: 1.7 !important;
  font-family: inherit !important;
  color: inherit !important;
}

/* 操作按钮栏 */
.bot-footer {
  display: flex;
  align-items: center;
  gap: 12px;
}
.msg-actions {
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s;
}
.ai-zaosheng-msg.bot:hover .msg-actions {
  opacity: 1;
}
.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  color: #999;
  font-size: 12px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s;
}
.action-btn:hover {
  background: #f5f5f5;
  color:#e85d04;
}
.action-btn svg {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

/* 推荐问题 */
.recommended-questions {
  padding: 16px;
  background: #f8f9fb;
  border-radius: 12px;
  border: 1px solid #f0f2f5;
}
.rec-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
  font-weight: 500;
}
.rec-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rec-item {
  background: #fff;
  border: 1px solid #edf1f7;
  color:#e85d04;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
}
.rec-item:hover {
  border-color:#e85d04;
  background: #fff6f0;
  transform: translateX(4px);
}

.time {
  font-size: 11px;
  color: #ccc;
}
.ai-zaosheng-msg.user .time {
  text-align: right;
}

/* 正在输入动效 - 飞行主题优化版 */
.loading-plane-container {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 12px;
  background: transparent;
  width: fit-content;
  /* 整体浮动，保持同步 */
  animation: float-up-down 2s ease-in-out infinite;
}

@keyframes float-up-down {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

.plane-icon {
  color:#e85d04;
  /* 旋转90度让飞机朝右 */
  transform: rotate(90deg);
  display: flex;
  align-items: center;
}

.wind-lines {
  display: flex;
  flex-direction: column;
  gap: 3px;
  /* 气流在左侧，紧贴飞机 */
  margin-right: -2px; /* 让气流稍微切入飞机尾部视觉区域 */
  justify-content: center;
  align-items: flex-end; /* 线条靠右对齐（靠近飞机尾部） */
  height: 12px; /* 限制高度，使其集中 */
}

.wind-line {
  height: 2px;
  /* 渐变方向：右侧(靠近飞机)深色 -> 左侧透明 */
  background: linear-gradient(270deg, rgba(232, 93, 4, 0.8), transparent);
  border-radius: 2px;
  opacity: 0;
  width: 0;
  animation: jet-stream 1s ease-out infinite;
}

.wind-line:nth-child(1) { animation-delay: 0s; animation-duration: 0.9s; }
.wind-line:nth-child(2) { animation-delay: 0.3s; animation-duration: 1.1s; }
.wind-line:nth-child(3) { animation-delay: 0.15s; animation-duration: 0.8s; }

@keyframes jet-stream {
  0% {
    width: 4px;
    opacity: 0;
    transform: translateX(2px);
  }
  30% {
    opacity: 0.8;
    width: 14px;
  }
  100% {
    width: 20px;
    opacity: 0;
    transform: translateX(-8px);
  }
}

/* 输入区 */
.ai-zaosheng-input-wrap {
  padding: 12px 24px 16px;
  background: #fff;
  border-top: none;
}
.ai-zaosheng-input-container {
  display: flex;
  align-items: center;
  background: #f4f4f4;
  border-radius: 24px;
  padding: 8px 12px 8px 12px; /* Adjusted padding-left */
  transition: all 0.2s;
  border: 1px solid transparent;
}

.digital-human-bubble-trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #fff;
  color: #666;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 8px;
  transition: all 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
}
.digital-human-bubble-trigger:hover {
  color:#e85d04;
  border-color:#e85d04;
  background: #fff6f0;
}
.digital-human-bubble-trigger svg {
  fill: currentColor;
}
.ai-zaosheng-input-container:focus-within {
  background: #fff;
  border-color:#e85d04;
  box-shadow: 0 4px 12px rgba(232, 93, 4, 0.08);
}
.ai-zaosheng-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 8px 0;
  font-size: 15px;
  line-height: 1.5;
  max-height: 120px;
  resize: none;
  outline: none;
  color: #333;
}
.ai-zaosheng-input::placeholder {
  color: #999;
}
.input-actions {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.ai-zaosheng-send-v2, .ai-zaosheng-stop-v2 {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background:#e85d04;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}
.ai-zaosheng-send-v2:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.ai-zaosheng-send-v2:hover:not(:disabled) {
  transform: scale(1.05);
  background: #dc2f02;
}
.ai-zaosheng-stop-v2 {
  background: #333;
}
.ai-zaosheng-send-v2 svg, .ai-zaosheng-stop-v2 svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}
.input-footer-tip {
  font-size: 12px;
  color:#e85d04;
  text-align: center;
  margin-top: 8px;
}

.ai-zaosheng-close {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #999;
  border-radius: 6px;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-zaosheng-close:hover {
  background: #f5f5f5;
  color: #666;
}

.ai-zaosheng-welcome {
  text-align: center;
  color: #888;
  font-size: 14px;
  padding: 40px 24px;
  line-height: 1.8;
  margin: 0;
}
.ai-zaosheng-welcome strong {
  color: #333;
  font-size: 18px;
  display: block;
  margin-bottom: 8px;
}

/* 招生简章按钮及悬浮提示 */
.brochure-btn-container {
  position: relative;
  display: inline-block;
}

.brochure-btn {
  height: 28px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg,#e85d04 0%, #dc2f02 100%);
  color: #fff;
  border: none;
  padding: 0 14px;
  border-radius: 14px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(232, 93, 4, 0.2);
  position: relative;
  text-decoration: none; /* Ensure no underline for anchor */
}

.brochure-btn:hover {
  opacity: 0.9;
}

/* 自定义悬浮提示 (Tooltip) */
.brochure-btn::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%) translateY(5px);
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  pointer-events: none;
  z-index: 1001;
}

.brochure-btn:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

/* 招生简章表单气泡式弹窗 (位于按钮上方) */
.brochure-form-popup {
  position: absolute;
  bottom: calc(100% + 12px);
  right: 0;
  width: 320px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  overflow: visible;
  z-index: 1100;
  animation: popup-fade-in 0.3s ease-out;
  border: 1px solid #f0f0f0;
}

@keyframes popup-fade-in {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.popup-arrow {
  position: absolute;
  top: 100%;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #fff;
  filter: drop-shadow(0 2px 2px rgba(0,0,0,0.05));
}

.form-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-header h3 {
  margin: 0;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.form-close {
  background: transparent;
  border: none;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 0 4px;
}
.form-body {
  padding: 16px;
}
.form-item {
  margin-bottom: 12px;
}
.form-item label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 6px;
}
.radio-group {
  display: flex;
  gap: 20px;
}
.radio-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
}
.form-item input[type="text"] {
  width: 100%;
  height: 36px;
  background: #f8f9fb;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 13px;
  outline: none;
  transition: all 0.2s;
}
.form-item input[type="text"]:focus {
  background: #fff;
  border-color:#e85d04;
}
.form-footer {
  padding: 0 16px 16px;
}
.submit-btn {
  width: 100%;
  height: 38px;
  background: linear-gradient(135deg,#e85d04 0%, #dc2f02 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.submit-btn:hover {
  opacity: 0.95;
  box-shadow: 0 4px 12px rgba(232, 93, 4, 0.3);
}

/* 溯源相关样式 (简约版) */
:deep(.citation-tag) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  height: 14px;
  background: rgba(232, 93, 4, 0.08);
  color:#e85d04;
  font-size: 10px;
  padding: 0 4px;
  border-radius: 4px;
  margin: 0 2px;
  cursor: pointer;
  transition: all 0.2s;
  vertical-align: super;
  font-weight: 500;
}
:deep(.citation-tag:hover) {
  background:#e85d04;
  color: #fff;
}

/* 简约溯源脚注 */
.sources-minimal-wrap {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px dashed #f0f0f0;
}
.sources-label {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
  margin-top: 2px;
}
.sources-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.source-tag-mini {
  font-size: 12px;
  color: #666;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f8f9fb;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}
.source-tag-mini:hover {
  background: #fff6f0;
  color:#e85d04;
}
.source-tag-mini-default {
  font-size: 12px;
  color: #862d28;
  background: #f8f9fb;
  padding: 2px 8px;
  border-radius: 4px;
  font-style: italic;
}
.source-tag-mini .tag-idx {
  font-weight: bold;
  font-family: monospace;
  opacity: 0.8;
}

/* 溯源详情弹窗 */
.source-detail-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  z-index: 200000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;
}
.source-detail-modal {
  width: 500px;
  max-width: 90vw;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  overflow: hidden;
  animation: modalIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes modalIn { from { opacity: 0; transform: scale(0.9) translateY(20px); } to { opacity: 1; transform: scale(1) translateY(0); } }

.source-detail-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.source-detail-header h3 { margin: 0; font-size: 16px; color: #333; }
.source-detail-header button {
  background: none; border: none; font-size: 24px; color: #999; cursor: pointer; line-height: 1;
}
.source-detail-body { padding: 20px; display: flex; flex-direction: column; gap: 16px; }
.source-detail-item label { display: block; font-size: 12px; color: #999; margin-bottom: 6px; }
.source-detail-item .val { font-size: 14px; color: #333; line-height: 1.6; }
.source-detail-item .val.content-text {
  background: #f8f9fb; padding: 12px; border-radius: 8px; border: 1px solid #edf1f7;
  max-height: 300px; overflow-y: auto;
}

/* 悬浮详情 */
.source-hover-popover {
  position: fixed;
  z-index: 200000;
  width: 350px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  transform: translate(-50%, -100%);
  margin-top: -10px;
  animation: popover-fade 0.2s ease-out;
}
@keyframes popover-fade {
  from { opacity: 0; transform: translate(-50%, -90%); }
  to { opacity: 1; transform: translate(-50%, -100%); }
}
.hover-popover-content {
  padding: 16px;
}
.hover-popover-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.hover-popover-text {
  font-size: 13px;
  line-height: 1.6;
  color: #555;
  max-height: 200px;
  overflow-y: auto;
}
.hover-popover-arrow {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #fff;
}

/* 之前的老样式清理 (可选，为了保持代码整洁) */
.sources-list, .source-card, .source-idx, .source-name, .sources-list-container, .sources-header, .sources-items-wrap, .source-group-card, .source-segment-tag {
  display: none !important;
}
</style>
